export const checkURL = (url: any) => !url.includes('/Data_Entries') && !url.includes('/comments');
